import type { RootState } from 'app/store/root/root.state';
import type { Uuid } from 'shared/common/types';
import { createSelector } from '@ngrx/store';
import { selectRootState } from 'app/store/root/root.state';
import * as fromUsers from './users.reducer';

export const usersState = createSelector(
  selectRootState,
  state => state.users,
);

export const users = createSelector(
  selectRootState,
  state => fromUsers.selectAll(state.users),
);

export const oneUser = createSelector(
  selectRootState,
  (state: RootState, props: { id: Uuid }) => fromUsers.selectEntities(state.users)[props.id],
);
